
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import aCallable$1 from './a-callable.js';
import isNullOrUndefined$1 from './is-null-or-undefined.js';

var aCallable = aCallable$1;
var isNullOrUndefined = isNullOrUndefined$1;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

export { getMethod as default };
//# sourceMappingURL=get-method.js.map
